import React from 'react'
import { Link, useLocation, useHistory} from "react-router-dom";

  

const Navbar = () => {
    let location = useLocation();
    let history = useHistory();
    const handleLogout = () =>{
        localStorage.removeItem('token');
        history.replace('/login');
    }
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">Videsh</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon">gthhhh</span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/"? "active": ""}`} aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname==="/form"? "active": ""}`} aria-current="page" to="/form">Create Resume</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${location.dashboard==="/dashboard"? "active": ""}`} to="/dashboard">Admin Page</Link>
                        </li>

                    </ul>
                    {!localStorage.getItem('token') ? <form className="d-flex"> 
                    <Link className="btn btn-primary mx-1" to="/login" role="button">Login</Link>
                    <Link className="btn btn-primary mx-1" to="/signup" role="button">Signup</Link>
                    </form> : <button className='btn btn-primary mx-1' onClick={handleLogout}>Logout</button>}
                </div>
            </div>
        </nav>
    )
}

export default Navbar
